import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: React.ReactNode;
  container?: Element;
  hideBodyScroll: boolean;
}

const Portal = (props: PortalProps): React.ReactPortal => {
  const scrollbarWidth = useRef(`${window.innerWidth - document.body.clientWidth}px`).current;

  useEffect(() => {
    const html = document.querySelector("html");
    if (props.hideBodyScroll) {
      html.classList.add("portal-open");
      html.style.marginRight = scrollbarWidth;
    }

    return () => {
      if (props.hideBodyScroll) {
        document.querySelector("html").classList.remove("portal-open");
        html.style.marginRight = "unset";
      }
    }
  }, [props.hideBodyScroll]);

  return createPortal(props.children, props.container || document.body);
}

export default Portal;
